<template>
    <div>
        <CCol sm="12" class="p-0">
    
    
            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
                <CRow class="p-2">
    
                    <CCol sm="12">
                        <CCard class="bg-FFF custom-border-radius-12px">
                            <CRow class="justify-content-center m-2">
                                <CCol sm="2" @click="navigateTo('SettingPersonalDetail')">
                                    <div class="text-center m-3">
                                        <img src="../assets/img/icon-profile.png" style="max-width:50px" />
                                        <h3 class="custom-24px-500 mt-2 custom-wordwrap-initial">Personal Detail</h3>
                                    </div>
                                </CCol>
                                <CCol sm="2" @click="navigateTo('SettingEmployment')">
                                    <div class="text-center m-3">
                                        <img src="../assets/img/set-employment.png" style="max-width:50px" />
                                        <h3 class="custom-24px-500 mt-2 custom-wordwrap-initial">Employment</h3>
                                    </div>
                                </CCol>
                                <CCol sm="2" @click="navigateTo('SettingContact')">
                                    <div class="text-center m-3">
                                        <img src="../assets/img/set-contact.png" style="max-width:50px" />
                                        <h3 class="custom-24px-500 mt-2 custom-wordwrap-initial">Contact</h3>
                                    </div>
                                </CCol>
                                <CCol sm="2" @click="navigateTo('SettingFamilyDetail')">
                                    <div class="text-center m-3">
                                        <img src="../assets/img/set-family.png" style="max-width:50px" />
                                        <h3 class="custom-24px-500 mt-2 custom-wordwrap-initial">Family Detail</h3>
                                    </div>
                                </CCol>
                                <CCol sm="2" @click="navigateTo('SettingCompensation')">
                                    <div class="text-center m-3">
                                        <img src="../assets/img/set-compensation.png" style="max-width:50px" />
                                        <h3 class="custom-24px-500 mt-2 custom-wordwrap-initial">Compensation</h3>
                                    </div>
                                </CCol>
                                </CRow>
                                <CRow class="justify-content-center">
                                <CCol sm="2" @click="navigateTo('SettingDocument')">
                                    <div class="text-center m-3">
                                        <img src="../assets/img/set-document.png" style="max-width:50px" />
                                        <h3 class="custom-24px-500 mt-2 custom-wordwrap-initial">Document</h3>
                                    </div>
                                </CCol>
                                <CCol sm="2" @click="navigateTo('SettingEquipment')">
                                    <div class="text-center m-3">
                                        <img src="../assets/img/set-equipment.png" style="max-width:50px" />
                                        <h3 class="custom-24px-500 mt-2 custom-wordwrap-initial">Equipment</h3>
                                    </div>
                                </CCol>
                                <CCol sm="2" @click="navigateTo('SettingLeavePolicy')">
                                    <div class="text-center m-3">
                                        <img src="../assets/img/set-leave.png" style="max-width:50px" />
                                        <h3 class="custom-24px-500 mt-2 custom-wordwrap-initial">Leave Policy</h3>
                                    </div>
                                </CCol>
                                <CCol sm="2" @click="navigateTo('SettingClaimPolicy')">
                                    <div class="text-center m-3">
                                        <img src="../assets/img/set-claim.png" style="max-width:50px" />
                                        <h3 class="custom-24px-500 mt-2 custom-wordwrap-initial">Claim Policy</h3>
                                    </div>
                                </CCol>
                                <CCol sm="2" @click="navigateTo('SettingDisciplinary')">
                                    <div class="text-center m-3">
                                        <img src="../assets/img/set-disciplinary.png" style="max-width:50px" />
                                        <h3 class="custom-24px-500 mt-2 custom-wordwrap-initial">Disciplinary</h3>
                                    </div>
                                </CCol>
    
                            </CRow>
                            <CRow class="justify-content-center">
                                <CCol sm="2" @click="navigateTo('SettingAppSetting')">
                                    <div class="text-center m-3">
                                        <img src="../assets/img/set-app.png" style="max-width:50px" />
                                        <h3 class="custom-24px-500 mt-2 custom-wordwrap-initial">App Setting</h3>
                                    </div>
                                </CCol>
    
                            </CRow>
                        </CCard>
                    </CCol>
    
                </CRow>
    
    
            </CCol>
    
        </CCol>
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {
            

        }





    },
    async mounted() {
        
            try {
                const isAuth = await this.UserAuth();
                if (isAuth) {
                    this.GetInfoUser();


                } else {
                    this.GoToPage();
                }
            } catch (error) {
                this.GoToPage();
                console.error("Error during authentication:", error);
                // Handle the error here
            }

    },

    computed: {

    },
    created() {
    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        // navigateTo(pageName) {
        //     const id = this.$route.query.id; // Retrieve the `id` from the current route
        //     if (!id) {
        //         console.error("ID is missing in the query parameters!");
        //         return;
        //     }
        //     this.$router.push({ name: pageName, query: { id } }); // Pass the `id` to the next page
        // },
        async navigateTo(pageName) {
            let id = this.$route.query.id; // Retrieve the `id` from the current route

            if (!id) {
                console.warn("ID is missing in the query parameters!");

                // Fetch the user ID using GetInfoUser method
                try {
                    await this.GetInfoUser(); // Call GetInfoUser to populate `this.user`
                    id = this.user?.id; // Assume `this.user` contains `id` after fetching

                    if (!id) {
                        console.error("Unable to retrieve user ID from user information.");
                        alert("An error occurred. Please log in again.");
                        return this.$router.push({ path: "/Login" }); // Redirect to login if ID is missing
                    }
                } catch (error) {
                    console.error("Error retrieving user ID:", error);
                    alert("An error occurred. Please log in again.");
                    return this.$router.push({ path: "/Login" });
                }
            }

            // Navigate to the specified page with the resolved `id` as query parameter
            this.$router.push({ name: pageName, query: { id } });
        },
        GoToSettingPersonalDetail()
        {
            this.$router.push("SettingPersonalDetail");
        },
        GoToSettingEmployment()
        {
            this.$router.push("SettingEmployment");
        },
        GoToSettingContact()
        {
            this.$router.push("SettingContact");
        },
        GoToSettingFamilyDetail()
        {
            this.$router.push("SettingFamilyDetail");
        },
        GoToSettingCompensation()
        {
            this.$router.push("SettingCompensation");
        },
        GoToSettingDocument()
        {
            this.$router.push("SettingDocument");
        },
        GoToSettingEquipment()
        {
            this.$router.push("SettingEquipment");
        },

        GoToSettingLeavePolicy()
        {
            this.$router.push("SettingLeavePolicy");
        },
        GoToSettingClaimPolicy()
        {
            this.$router.push("SettingClaimPolicy");
        },
        GoToSettingDisciplinary()
        {
            this.$router.push("SettingDisciplinary");
        },
        GoToSettingAppSetting()
        {
            this.$router.push("SettingAppSetting");
        },
    }

};
</script>